export default {
    computed: {
        rules() {
            let email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            let ip_regex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

            return {
                required: v => !!v || 'Обязательное поле.',
                nameRule: min => {
                    return v => (v && v.length > min && v != 'Не задано') || `Требуется значение с количеством символов больше ${min}`
                },
                emailRule: v => (!v || email_regex.test(v) || v == 'Не задано') || 'E-mail не валиден',
                ipRule:  v => ip_regex.test(v) || 'Ip не валиден',
                portRule: v => (v > 0 && v < 65536) || 'Порт не валиден',
                numberRule: v => !isNaN(parseFloat(v)) || 'Значение должно быть числом'
            }
        }
    }
}